<template>
  <div class="home contact">
    <AccountSetLayout
      layoutType="AccountSet"
      layoutTitile="联系方式"
    >
      <Tips
        title="注意事项"
        :tips="$t('tips')"
        class="withdrawal-tips"
      />
      <Type1Verify :info="info" />
      <Type2Verify :user_name="user_name" />
      <Type3Verify :user_name="user_name" />
    </AccountSetLayout>
  </div>
</template>

<i18n>
{
  "en": {
    "tips": [
      "1.根据监管要求，请如实登记身份认证信息。",
      "2.验证等级分为3级，依次为：手机验证、初级实名验证、高级实名验证。",
      "3.未完成手机验证前，无法使用官网各项功能，手机验证后才可以接收短信验证码，请务必完成，手机号可以修改，完成手机验证后，即可进行 JD卡 兑换，最大额度为 50 元。",
      "4.由于验证接口限制，进行过运营商携号转网操作的手机号无法完成实名验证，请更换为未进行过携号转网操作的手机号。",
      "5.初级实名验证需要提供姓名及身份证号，手机号/姓名/身份证号 三个信息必须为同一实名主体，完成初级实名验证后，可以进行 100 元 JD卡 的兑换操作，单账号每月额度为 800 元，无兑换手续费。",
      "6.高级实名验证需要提供身份证正反面照片，手机号/姓名/身份证号/身份证正反面 四种信息必须为同一实名主体。完成高级实名验证后，可以进行 支付宝提现，单人单月上限 98000 元：",
      "（1）账号 支付宝提现 需要收取 5% 的提现手续费，与现行一致；",
      "（2）单账号总上行带宽达到 10Gbps及以上，可以联系官方管理人员，开通特权提现通道。",
      "7.身份验证后无法修改，请保证验证信息真实性。" 
    ]
  }
}
</i18n>


<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import AccountSetLayout from "@/components/AccountSet/AccountSetLayout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { Message } from "element-ui";
import ImageCode from "@/components/ImageCode.vue";
import SendEmailCode from "@/components/SendEmailCode.vue";
import { LANG } from "../../config/contant.js";
import VueRecaptcha from "vue-recaptcha";
import Tips from "@/components/Common/Tips.vue";
import SendVerifyCode from "@/components/Common/SendVerifyCode.vue";
import Type1Verify from "@/components/AccountSet/Type1Verify.vue";
import Type2Verify from "@/components/AccountSet/Type2Verify.vue";
import Type3Verify from "@/components/AccountSet/Type3Verify.vue";

export default {
  name: "home",
  components: {
    BasiceLayout,
    AccountSetLayout,
    ImageCode,
    SendEmailCode,
    VueRecaptcha,
    Tips,
    SendVerifyCode,
    Type1Verify,
    Type2Verify,
    Type3Verify
  },
  computed: mapState({}),
  data() {
    return {
      contact: "",
      user_name: "",
      tel: "",
      type: "EDIT",
      verifyCode: "",
      noIcon: false,
      nameVerStatus: '',
      IDCard: '',
      info: ''
    };
  },
  created() {
    this.updateContact();
  },
  methods: {
    ...mapActions(["getContact", "setContact"]),
    verifyTel() {
      let { user_name, contact, tel, verifyCode } = this;

      if (!user_name || !contact || !tel || !verifyCode) {
        return Message({
          message: "请完整填写信息",
          type: "error",
        });
      } else {
        this.setContact({
          contact,
          user_name,
          tel,
          verifyCode,
          type: "TEL"
        }).then((res) => {
          if (res.code === 200) {
            this.type === "WaitEdit";
            Message({
              message: "保存成功",
              type: "success",
            });
            this.updateContact();
          } else {
            Message({
              message: res.message || "网络失败",
              type: "error",
            });
          }
        });
      }
    },
    clickCommitContact() {
      let { user_name, contact, tel, verifyCode, IDCard } = this;

      if (!user_name || !contact || !tel || !verifyCode) {
        return Message({
          message: "请完整填写信息",
          type: "error",
        });
      } else {
        this.setContact({
          contact,
          user_name,
          tel,
          verifyCode,
          IDCard
        }).then((res) => {
          if (res.code === 200) {
            this.type === "WaitEdit";
            Message({
              message: "保存成功",
              type: "success",
            });
            this.updateContact();
          } else {
            Message({
              message: res.message || "网络失败",
              type: "error",
            });
          }
        });
      }
    },
    // 获取最新联系方式
    updateContact() {
      this.getContact().then((res) => {
        if (res.data && res.data.contact) {
          let data = res.data;
          this.type = "WaitEdit";
          this.contact = data.contact;
          this.user_name = data.user_name;
          this.tel = data.tel;
          this.telVerStatus = data.telVerStatus;
          this.nameVerStatus = data.nameVerStatus;
          this.IDVerStatus = data.IDVerStatus;
          this.IDCard = data.IDCard;

          this.info = res.data;

          if (!data.telVerStatus) {
            Message({
              message: "根据实名认证要求，请完成手机号绑定。",
              type: "error",
            });
          }
        } else {
          Message({
            message: "根据实名认证要求，请完成手机号绑定。",
            type: "error",
          });
          this.type = "EDIT";
        }
      });
    },
    verifyCodeTip(error) {
      if (error && error.message) {
        Message({
          message: error.message,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="stylus">
.contact-commit-wrap {
  text-align: center;
  margin-bottom: 50px;
}

.contact .el-input {
  max-width: 300px;
}

.account-wrap .left-item {
  display: flex;
  justify-content: flex-start;
  width: 100px;
}

.right-text{
  min-width: 100px
}

.right-item.margin-left-20 {
  min-width: 250px;
}
.is-mobile{
  .right-text{
    margin-left: 20px;
    font-weight: 400;
    font-size: 14px;
  }
}
.email_wrap{
  width: 200px;
}
</style>

